import moment from 'moment';

const LIMIT_MIN_DATE = '2000-01-01';

export function genererObjectErrorAdresse() {
  return {
    adresse1: false,
    ville: false,
    latitude: false,
    longitude: false,
  };
}

export function isInvalidAddressGescom(address) {
  return !address
  || !address.ville
  || address.latitude === null
  || address.longitude === null;
}

export function getErrorsAdresse(address) {
  return {
    adresse1: !address || !address.adresse1,
    ville: !address || !address.ville,
    latitude: !address || isNaN(parseFloat(address.latitude)),
    longitude: !address || isNaN(parseFloat(address.longitude)),
  };
}

export function isValidNumberRequired(value) {
  return typeof value === 'number';
}

export function isInvalidDate(date, required = false) {
  if (required) return !date || !moment(date).isValid() || date < moment(LIMIT_MIN_DATE);
  if (!date) return false;
  return !moment(date).isValid() || date < moment(LIMIT_MIN_DATE);
}

export function isValidPeriode(periode) {
  if (!moment(periode.dateFin).isValid() && !moment(periode.dateDebut).isValid()) return true;
  if (moment(periode.dateDebut).isValid() && !moment(periode.dateFin).isValid()
   || moment(periode.dateFin).isValid() && !moment(periode.dateDebut).isValid()) return false;
  return moment(periode.dateFin).isSameOrAfter(periode.dateDebut);
}
